import React from "react";
import { Gift } from "lucide-react";
import useOpener from "../../../../hooks/useOpener";
import ReserveFreeTrialModal from "./ReserveFreeTrialModal";

const FloatingActionButton: React.FC = () => {
  const { onClose, onOpen, open } = useOpener();
  return (
    <>
      <div className="fixed bottom-[100px] sm:bottom-6 right-4 sm:left-6 z-50">
        <button
          onClick={onOpen}
          className="relative flex items-center gap-2 px-6 py-3 border border-primaryColor bg-white text-primaryColor font-semibold rounded-full shadow-lg 
                transition-transform duration-300 hover:scale-110 justify-center"
        >
          <Gift className="w-5 h-5 animate-twinkle" />
          Reserve My Free Trial
        </button>
      </div>

      {open && <ReserveFreeTrialModal onClose={onClose} />}
    </>
  );
};

export default FloatingActionButton;
